export class ValidationRuleDTO{

    public id!: number;
    public inputFieldReference!: string;
    public validationRuleDefinitionId!: number;
    public validationParameter1!: string;
    public validationParameter2!: string;
    public severity!: number;
    public validationMessage!: string;
}